import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { ILeadSearchView } from '../../aida/viewModels/leads/interfaces';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'lead/followUps';
const PAGE_SIZE = 25;

export function useLeadFollowUpsInfiniteQuery({
	userId,
	outcomeName,
	meta,
}: {
	userId?: string;
	outcomeName?: string;
	meta?: LevStandardQueryMeta;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery<Api.IPagedCollection<ILeadSearchView>>({
		queryKey: [BASE_QUERY_KEY, userId, outcomeName],
		queryFn: ({ pageParam }) =>
			userSession.webServiceHelper.callAsync<Api.IPagedCollection<ILeadSearchView>>(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: { outcomeName, pageSize: PAGE_SIZE, pageToken: pageParam as string, userId },
					urlPath: 'lead/followUps',
				}),
				'GET'
			),
		getNextPageParam: lastPage => lastPage.pageToken || undefined,
		initialPageParam: '',
		meta,
	});
}

export const invalidateLeadFollowUpsQueries = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
